<template>
  <LayoutMenuDesktopContainer>
    <template #left>
      <KeepAlive>
        <li
          v-for="(item, index) in formatResourcesMenu"
          :key="hash(item)"
          class="mb-0.5 last:mb-0"
        >
          <MenuLink
            :data="item"
            :current="current === index"
            @click="handleClick(item, index)"
          />
        </li>
      </KeepAlive>
    </template>
    <template #right>
      <LayoutMenuDesktopContent
        v-if="currentData"
        :type="menuName.RESOURCES"
        :link="currentData?.link"
      >
        <KeepAlive>
          <LayoutMenuDesktopCategory
            v-for="(item, index) in formatResourcesMenu"
            v-show="current === index"
            :key="hash(item)"
            :list="item.subMenus"
          />
        </KeepAlive>
      </LayoutMenuDesktopContent>
    </template>
  </LayoutMenuDesktopContainer>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import MenuLink from '@/components/Layout/Menu/Desktop/MenuLink.vue';
  import validIsNuxtLink from '@/components/Layout/Menu/validIsNuxtLink';
  import type { IFormatMenu } from '@/stores/menuStore';

  const menuStore = useMenuStore();
  const { menuName, formatResourcesMenu } = storeToRefs(menuStore);

  const current = ref<number>(0);

  const currentData = computed(
    (): IFormatMenu | null => formatResourcesMenu.value[current.value] || null
  );

  const handleClick = (payload: IFormatMenu, index: number): void => {
    if (!validIsNuxtLink(payload)) {
      current.value = index;
    }

    window.gtag('event', 'site_click', {
      Item: 'Navigation',
      Item_Cate: menuName.value.RESOURCES,
      Item_Name: payload.name,
    });
  };
</script>
